import { render } from "./PushNotificationMaster.vue?vue&type=template&id=21d9cf1e&scoped=true"
import script from "./PushNotificationMaster.vue?vue&type=script&lang=js"
export * from "./PushNotificationMaster.vue?vue&type=script&lang=js"

import "./PushNotificationMaster.vue?vue&type=style&index=0&id=21d9cf1e&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d9cf1e"]])

export default __exports__